var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.viewedBy.length)?_c('section-box',{staticClass:"viewed_by_box"},[_c('p',{staticClass:"viewed_by_box--text"},[_vm._v("Record being viewed by "+_vm._s(_vm.viewedByString))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }